module.exports = __webpack_public_path__ + "static/img/9.fe6b279.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/partner/9.png
// module id = 9GLF
// module chunks = 45